export { default } from './BoxWithGradient';
